import { FC } from 'react';
import { useUpdateQuestion } from '@/api/useAdminPastPaper';
import { Database } from '@/_constants/database.types';
import { ContentStatus, CONTENT_STATUS_OPTIONS } from '@/_constants/statusOptions';

type QuestionRow = Database['public']['Tables']['questions']['Row'];

type QuestionStatusSelectProps = {
  question: QuestionRow;
  pastPaperId: string;
};

const QuestionStatusSelect: FC<QuestionStatusSelectProps> = ({ question, pastPaperId }) => {
  const { mutate: updateQuestion } = useUpdateQuestion();

  const handleChange = (newStatus: ContentStatus) => {
    updateQuestion({
      questionId: question.id,
      pastPaperId,
      updates: { status: newStatus },
    });
  };

  return (
    <select
      value={question.status}
      onChange={(e) => handleChange(e.target.value as ContentStatus)}
      className="px-2 py-1 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C87941] focus:border-transparent"
    >
      {CONTENT_STATUS_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default QuestionStatusSelect;
